import epochToFormattedDateTime from "utils/formatter-utils/date-formatter";
import BlockyHeavyText from "components/custom-texts/blocky-heavy-text";
import BlockyMediumText from "components/custom-texts/blocky-medium-text";
import CountdownClock from "../pool-item/countdown-clock";
import { isPoolClosed } from "utils/pool/is-pool-closed";
import BlockyBoldText from "components/custom-texts/blocky-bold-text";
import ContestAddition from "../pool-item/contest-addition";
import { formatAsCurrency } from "utils/formatter-utils/currency-formatter";
import { SetStateAction, useState } from "react";
import listItemStyles from "assets/shared-stylesheets/sparket-list-item.module.css";
import { InfoCircle } from "react-bootstrap-icons";
import RulesModal from "components/pool-details/rules-modal";
import ContestantCard from "./contestant-card";
import { Entry } from "interfaces/entry";
import { Card } from "react-bootstrap";
import { useAppSelector } from "state/hooks";
import { getCardColor, getTextColor } from "state/slices/group-slice";
import { Pool } from "interfaces/pool.ts";

interface HomepagePoolItemProps {
  pool: Pool;
  showCountDownClock: boolean;
  isContestPool?: boolean;
  setSelectedEntry: SetStateAction<any>;
  isAllowedToBet: () => Promise<boolean>;
  contestEntryId?: string;
}

const HomepagePoolItem = ({
  pool,
  showCountDownClock,
  isContestPool,
  setSelectedEntry,
  isAllowedToBet,
  contestEntryId,
}: HomepagePoolItemProps) => {
  const [wasClickedId, setWasClickedId] = useState(-1);
  const [showRulesModal, setShowRulesModal] = useState(false);

  const textColor = useAppSelector(getTextColor);
  const cardColor = useAppSelector(getCardColor);

  const handleContestantClick = async (entry: any) => {
    if (await isAllowedToBet()) {
      setSelectedEntry(entry);
      setWasClickedId(entry.pool_entry_id);
      setSelectedEntry(entry, pool);
    }
  };

  const totalSeedDistribution = (pool.entries ?? []).reduce(
    (acc: number, item: Entry) => {
      return acc + item.seed_distribution;
    },
    0
  );

  return (
    <>
      <div
        className={listItemStyles.itemContainer}
        style={{
          minHeight: 90,
          marginLeft: 0,
          marginRight: 0,
          height: 250,
          backgroundColor: cardColor,
          color: textColor,
        }}
      >
        <div
          className={listItemStyles.leftColumnContainer}
          style={{ flex: 0.98, paddingTop: 5 }}
        >
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div>
              <BlockyHeavyText
                style={{
                  fontSize: 10,
                  whiteSpace: "nowrap",
                }}
              >
                {pool.event_name}
              </BlockyHeavyText>
              <BlockyHeavyText className={listItemStyles.poolNameText}>
                {pool.name}
              </BlockyHeavyText>
            </div>

            <InfoCircle
              onClick={(e) => {
                e.preventDefault();
                setShowRulesModal(true);
              }}
            />
          </div>
          <div
            style={{
              height: 140,
              overflow: "scroll",
              overflowX: "hidden",
              scrollbarColor: "gray " + cardColor,
            }}
          >
            <Card
              style={{
                position: "sticky",
                top: -1,
                backgroundColor: cardColor,
                color: textColor,
                fontSize: 11,
                zIndex: 100,
                borderRadius: 0,
                border: "none",
                width: "101%",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <div></div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    fontSize: 12,
                    width: 95,
                    paddingRight: 10,
                  }}
                >
                  <BlockyBoldText>Win %</BlockyBoldText>
                  <BlockyBoldText>Odds</BlockyBoldText>
                </div>
              </div>
            </Card>
            {(pool.entries ?? []).map((entry: Entry) => {
              const wasClicked =
                wasClickedId.toString() === entry.pool_entry_id;
              return (
                <ContestantCard
                  key={entry.pool_entry_id}
                  entry={entry}
                  handleContestantClick={handleContestantClick}
                  totalSeedDistribution={totalSeedDistribution}
                  wasClicked={wasClicked}
                  poolStatus={pool.status}
                  contestEntryId={contestEntryId}
                />
              );
            })}
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "flex-end",
              paddingRight: 15,
            }}
          >
            <div id="homepage-pool-item-pool-size">
              <div>
                <BlockyHeavyText className={listItemStyles.poolCloseDatePrefix}>
                  Pool Size:&nbsp;
                </BlockyHeavyText>
              </div>
              <BlockyMediumText style={{ fontSize: 12, display: "inline" }}>
                {formatAsCurrency(pool["total"])}
              </BlockyMediumText>
            </div>
            <div id="homepage-pool-item-close-date">
              <div>
                <BlockyBoldText className={listItemStyles.poolCloseDatePrefix}>
                  {isPoolClosed(pool.status) ? "Closed" : "Closes"}:
                </BlockyBoldText>
              </div>
              <BlockyMediumText style={{ fontSize: 12, display: "inline" }}>
                {epochToFormattedDateTime(pool.close)}
              </BlockyMediumText>
              <BlockyMediumText className={listItemStyles.closeDateText}>
                {showCountDownClock && (
                  <CountdownClock close={new Date(pool.close)} />
                )}
              </BlockyMediumText>
              {isContestPool && <ContestAddition status={pool.status} />}
            </div>
          </div>
        </div>
      </div>

      <div onClick={(e) => e.preventDefault()}>
        <RulesModal
          pool={pool}
          showRulesModal={showRulesModal}
          setShowRulesModal={setShowRulesModal}
        ></RulesModal>
      </div>
    </>
  );
};

export default HomepagePoolItem;
